export const pong = () => JSON.stringify({ type: 'pong' });
